import Entity from "./entity";
export default class MembershipTrade extends Entity<number> {
    membershipId:number=0;
    tradeType:number=0;//0卖出 1买入
    category:string='';
    linkMan:string='';
    phoneNumber:string='';
    courtName:string='';
    price:string='';
}
